import React, { useState } from 'react'
import _ from 'lodash'
import numeral from 'numeral'
import {
  Div, P, Loading, Button, H4,
} from 'konsys-ui'
import {
  Row, Col, AutoComplete, DatePicker, Checkbox, Select, Spin, message, Modal, Button as AntButton, Collapse,
} from 'antd'
import { Query, Mutation } from 'react-apollo'
import { theme } from '../../../styles/_variables'
import { TRUCK_INFO } from '../../../constants/graphql/query'
import { EJECT_TRAILER } from '../../../constants/graphql/mutation'
import { toSafeFloat } from '../../../utils/util-services'
import history from '../../../history'


export const EjectTrailerModal = ({
  modal, setModal, truckId, setDisableButton, plateNumber,
}) => (
    <Mutation
      mutation={EJECT_TRAILER}
    >{(doEject, { loading }) => (
      <Modal
        title='ยืนยันการถอดหางพ่วง'
        visible={modal}
        okText='ถอดหางพ่วง'
        onCancel={() => setModal(false)}
        onOk={() => {
          doEject({ variables: { truckId } }).then((resp) => {
            const response = resp.data.EjectTrailer
            if (response.success) message.success(response.message)
            else message.error(response.message)
            setDisableButton(true)
            setModal(false)
          })
        }}
      >
      <P>คุณต้องการถอดหางพ่วงจากรถบรรทุก <strong>{`ทะเบียน: ${plateNumber}`}</strong></P>
      </Modal>
    )}
    </Mutation>
)

export const b = () => {

}
